import MatchHeight from 'vanilla-js-match-height';

new MatchHeight('.homePageSection--featuredArticles .articleCard', 
    {
        byRow: true, 
        timeOut: 500
    }
);

new MatchHeight('.articleCard--collection .articleCard__title', 
    {
        byRow: true, 
        timeOut: 500
    }
);